export function getAzureResourceSubType(type: string): string | undefined {
    const regExp = /\(([^)]+)\)/;
    const matches = regExp.exec(type);
    if (matches !== null) {
        return matches[1];
    }
}
